import { Controller } from "@hotwired/stimulus"

// 고정 크기 박스(OG 이미지 캡처 등) 안에서 글자가 넘치면 제목 글자 크기를 줄여 맞춘다.
//
// this.element 가 고정 크기 박스(padding 포함)이고, text 타깃이 줄일 제목이다. 박스의 직계 흐름에 놓인
// 자식(제목·회사명 등)의 높이 합이 박스 내용 높이를 넘지 않을 때까지 제목 font-size 를 step 씩 줄인다.
// 웹폰트가 늦게 로드되면 글자 폭이 바뀌므로 fonts.ready 와 loadingdone 뒤에 다시 맞춘다.
export default class extends Controller {
  static targets = ["text", "measure"]
  static values = {
    min: { type: Number, default: 40 },
    step: { type: Number, default: 4 },
  }

  connect() {
    this.maxSize = parseFloat(getComputedStyle(this.textTarget).fontSize)
    this.refit = () => this.fit()
    this.fit()
    document.fonts.ready.then(this.refit)
    document.fonts.addEventListener("loadingdone", this.refit)
  }

  disconnect() {
    document.fonts.removeEventListener("loadingdone", this.refit)
  }

  fit() {
    let size = this.maxSize
    this.textTarget.style.fontSize = `${size}px`

    while (size > this.minValue && this.overflows()) {
      size = Math.max(this.minValue, size - this.stepValue)
      this.textTarget.style.fontSize = `${size}px`
    }
  }

  // justify-center 인 flex 박스는 위로도 넘쳐서 scrollHeight 로는 못 잰다. 자식 높이(margin 포함)를 더해 비교한다.
  overflows() {
    const box = this.element
    const boxStyle = getComputedStyle(box)
    const availableHeight = box.clientHeight - parseFloat(boxStyle.paddingTop) - parseFloat(boxStyle.paddingBottom)
    const availableWidth = box.clientWidth - parseFloat(boxStyle.paddingLeft) - parseFloat(boxStyle.paddingRight)

    let usedHeight = 0
    for (const child of this.measureTargets) {
      const style = getComputedStyle(child)
      usedHeight += child.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom)
      if (child.scrollWidth > availableWidth) return true
    }
    return usedHeight > availableHeight
  }
}
